<template>
    <div :class="['mobile-footer', theme]">
      <router-link to="/" class="footer-item" exact>
        <div class="icon" :style="{ fill: isActiveRoute('/') ? activeColor : iconColor }">
          <svg width="40" height="40" viewBox="0 0 24 24">
            <path d="M12 3L2 12h3v9h6v-6h2v6h6v-9h3z" />
          </svg>
        </div>
        <span :style="{ color: isActiveRoute('/') ? activeColor : textColor }">Home</span>
      </router-link>
  
      <router-link to="" class="footer-item">
        <div class="icon" :style="{ fill: isActiveRoute('') ? activeColor : iconColor }">
          <svg width="40" height="40" viewBox="0 0 24 24">
            <path d="M3 6l4 4-4 4v-8zM7 6h14v2H7zm0 4h14v2H7zm0 4h14v2H7z" />
          </svg>
        </div>
        <span :style="{ color: isActiveRoute('') ? activeColor : textColor }">Live Dealer</span>
      </router-link>
  
      <router-link to="/my-bets" class="footer-item">
  <div class="icon" :style="{ fill: isActiveRoute('/my-bets') ? activeColor : iconColor }">
    <svg width="40" height="40" viewBox="0 0 24 24">
      <path d="M12 4a8 8 0 1 1-7.464 4.999H3.05a.5.5 0 0 1-.354-.854l2.829-2.829a.5.5 0 0 1 .707 0l2.828 2.829a.5.5 0 0 1-.353.854H7.465A7 7 0 1 0 19 12h-2a5 5 0 1 1-5-5v2l3-3-3-3v2z"/>
    </svg>
  </div>
  <span :style="{ color: isActiveRoute('/my-bets') ? activeColor : textColor }">My Bets</span>
</router-link>
  
      <router-link to="/ex-game-category/IkxpdmUgQ2FzaW5vIg==/name" class="footer-item">
        <div class="icon" :style="{ fill: isActiveRoute('/ex-game-category/IkxpdmUgQ2FzaW5vIg==/name') ? activeColor : iconColor }">
          <svg width="40" height="40" viewBox="0 0 24 24">
            <path d="M12 2l9 9-9 9-9-9z" />
          </svg>
        </div>
        <span :style="{ color: isActiveRoute('/ex-game-category/IkxpdmUgQ2FzaW5vIg==/name') ? activeColor : textColor }">Casino</span>
      </router-link>
    </div>
  </template>
  
  <script>
  import { useRoute } from 'vue-router';
  
  export default {
    props: {
      theme: {
        type: String,
        default: 'dark', // dark or light
      },
    },
    setup() {
      const route = useRoute();
  
      const isActiveRoute = (path) => route.path === path;
  
      return {
        isActiveRoute,
      };
    },
    computed: {
      iconColor() {
        return this.theme === 'dark' ? '#aaa' : '#444';
      },
      textColor() {
        return this.theme === 'dark' ? '#ccc' : '#222';
      },
      activeColor() {
        return this.theme === 'dark' ? '#F6EF2F' : '#000000';
      },
    },
  };
  </script>
  
  <style scoped>
  .mobile-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
    z-index: 999;
    transition: background 0.3s;
  }
  .mobile-footer.dark {
    background: linear-gradient(180deg, #1c1c1c, #2e2e2e);
    border-top: 1px solid #444;
  }
  .mobile-footer.light {
    background: linear-gradient(180deg, #f8f8f8, #e4e4e4);
    border-top: 1px solid #ccc;
  }
  .footer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    font-size: 12px;
    transition: all 0.2s;
  }
  .icon {
    margin-bottom: 4px;
  }
  </style>
  